import React, { lazy } from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import RoleRestrictedRoute from 'utility/routing/RoleRestrictedRoute';
import { roles } from 'utility/constants/roles';
import DomainDetailsLayout from 'components/DomainDetailsLayout';

const Domains = lazy(() => import('pages/domains/Domains'));

const DnsZones = lazy(() => import('pages/domains/dns'));

const Ssls = lazy(() => import('pages/domains/Ssls'));

const DomainDetails = lazy(() => import('pages/domains/details'));

const DomainRegistration = lazy(
	() => import('pages/domains/details/registration/DomainRegistration'),
);

const DomainDNS = lazy(() => import('pages/domains/details/dns/DomainDNS'));

const SslDetails = lazy(() => import('pages/domains/details/SslDetails'));

const CreateDNSZone = lazy(
	() => import('pages/domains/details/dns/CreateDNSZone'),
);

const ReverseDns = lazy(() => import('pages/domains/ReverseDns'));

const CreateTransfer = lazy(() => import('pages/domains/CreateTransfer'));

const Cloudflare = lazy(() => import('pages/domains/Cloudflare'));

const CloudflareDetails = lazy(
	() => import('pages/domains/Cloudflare/Details'),
);
const NotFound = lazy(() => import('pages/NotFound'));

const DomainsRouter = () => {
	return (
		<Switch>
			<RoleRestrictedRoute
				exact
				path="/domain"
				component={Domains}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/dns"
				component={DnsZones}
				whitelistedRoles={[roles.PURCHASER]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/create-transfer"
				component={CreateTransfer}
				whitelistedRoles={[roles.PURCHASER]}
			/>
			<RoleRestrictedRoute
				path="/domain/dashboard/:domain"
				component={DomainDetails}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/registration/:domain"
				component={DomainRegistration}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/ssl"
				component={Ssls}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/ssl/dashboard/:domain"
				component={({ match }) => (
					<Redirect to={`/domain/${match.params.domain}/ssl`} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/dns/add"
				component={CreateDNSZone}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/ssl/add"
				component={() => (
					<Redirect to={{ pathname: '/domain/ssl', search: '?add=true' }} />
				)}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/dns/reverse-dns/:uniqId?"
				component={ReverseDns}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>

			<RoleRestrictedRoute
				path="/domain/dns/:domain"
				component={DomainDNS}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				exact
				path="/domain/cloudflare"
				component={Cloudflare}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<RoleRestrictedRoute
				path="/domain/cloudflare/:uniqId"
				component={CloudflareDetails}
				whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
			/>
			<Route path="/domain/:domain">
				<DomainDetailsLayout>
					<Switch>
						{/* TODO DEV-6088 add domain registration and dns pages here */}

						<RoleRestrictedRoute
							path="/domain/:domain/ssl"
							component={SslDetails}
							whitelistedRoles={[roles.PURCHASER, roles.TECHNICIAN]}
						/>
					</Switch>
				</DomainDetailsLayout>
			</Route>

			<Route>
				<NotFound />
			</Route>
		</Switch>
	);
};

export default DomainsRouter;
